import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { DeleteLooseCustomerRecipeInput } from './DeleteLooseCustomerRecipeInput';
import { DeleteLooseCustomerRecipeOutput } from './DeleteLooseCustomerRecipeOutput';

export class DeleteLooseCustomerRecipeService extends HttpServiceBase {

  handle = (input: DeleteLooseCustomerRecipeInput): Promise<Result<DeleteLooseCustomerRecipeOutput> | null> => {
    const promise = this.http.delete<Result<DeleteLooseCustomerRecipeOutput>>(`${this.baseUrlSislogApi}/v2/customer-recipe/${input.recipeId}/loose`);
    return promise;
  }
}